import { render } from "./MyShoppingCart.vue?vue&type=template&id=adcbbc52&scoped=true"
import script from "./MyShoppingCart.vue?vue&type=script&lang=js"
export * from "./MyShoppingCart.vue?vue&type=script&lang=js"

import "./MyShoppingCart.vue?vue&type=style&index=0&id=adcbbc52&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adcbbc52"]])

export default __exports__